import { render, staticRenderFns } from "./FeeStructure.vue?vue&type=template&id=cdd801ba&scoped=true"
import script from "./FeeStructure.vue?vue&type=script&lang=js"
export * from "./FeeStructure.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/contract_form/fee_structure.css?vue&type=style&index=0&id=cdd801ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd801ba",
  null
  
)

export default component.exports